import fetchFromApiServer from 'services/api';

export function fetchFundDetails(fund_ID) {
  const url = `funds/fund-details/${fund_ID}`;
  return fetchFromApiServer('GET', url, fund_ID);
}

export function fetchFundLlm(data) {
  const url = `funds/get-llm-config`;
  return fetchFromApiServer('GET', url, data);
}

export function fetchInviteMember(data) {
  const url = `invite-member/send-mail`;
  return fetchFromApiServer('POST', url, data);
}

export function fetchPortfolioDataDetails(data) {
  const url = `funds/get-portfolio-details`;
  return fetchFromApiServer('GET', url, data);
}

export function fetchPortfolioHolding(data) {
  const url = `funds/get-portfolio-holding`;
  return fetchFromApiServer('POST', url, data);
}

export function fetchPdfFund(data) {
  const url = `funds/pdf`;
  return fetchFromApiServer('POST', url, data);
}

export function fetchCompareFundData(data) {
  const url = `funds/compare`;
  return fetchFromApiServer('POST', url, data);
}

export function fetchUpdateCompareFundData(data) {
  const url = `funds/fund-compare-update`;
  return fetchFromApiServer('PUT', url, data);
}

export function fetchCompareFundField(data) {
  const url = `funds/compare-fields`;
  return fetchFromApiServer('POST', url, data);
}

export function fetchUsersList() {
  const url = `funds/getListUsers`;
  return fetchFromApiServer('GET', url, {});
}

export function fetchCompaniesList() {
  const url = `funds/getListCompanies`;
  return fetchFromApiServer('GET', url, {});
}

export function fetchPeoplesList() {
  const url = `funds/getListPeoples`;
  return fetchFromApiServer('GET', url, {});
}

export function addPerson(data) {
  const url = `funds/addPerson`;
  return fetchFromApiServer('POST', url, data);
}

export function addOrganization(data) {
  const url = `funds/addOrganization`;
  return fetchFromApiServer('POST', url, data);
}

export function fetchCioUsersList() {
  const url = `funds/cio-users-list`;
  return fetchFromApiServer('GET', url, {});
}

export function fetchSendEmail(data) {
  const url = `funds/send-mail`;
  return fetchFromApiServer('POST', url, data);
}

export function fetchSendEmailTemplate(data) {
  const url = `funds/send-mail-template`;
  return fetchFromApiServer('POST', url, data);
}

export function fetchDDDetails(fund_ID) {
  const url = `funds/get-ddChecklist`;
  return fetchFromApiServer('GET', url, {}, fund_ID);
}

export function fetchFundBenchmark(fund_id) {
  const url = `funds/fund-quartiles/${fund_id}`;
  return fetchFromApiServer('GET', url, fund_id);
}

export function updateFundBenchmark(data) {
  const url = `funds/set-benchmarks`;
  return fetchFromApiServer('PUT', url, data);
}

export function deleteFundBenchmark(data) {
  const url = `funds/delete-benchmarks`;
  return fetchFromApiServer('DELETE', url, {}, data);
}

export function addFundBenchmark(data) {
  const url = `funds/add-benchmarks`;
  return fetchFromApiServer('POST', url, {}, data);
}

export function fetchScoringMatrix(data) {
  const url = `funds/get-scoringMatrix`;
  return fetchFromApiServer('GET', url, {}, data);
}

export function updateDDList(data) {
  const url = `funds/update-ddChecklist`;
  return fetchFromApiServer('PUT', url, data);
}

export function updateScoringMatrix(data) {
  const url = `funds/update-scoringMatrix`;
  return fetchFromApiServer('PUT', url, data);
}

export function fetchSectionList(data) {
  const url = `funds/fund-sections-review`;
  return fetchFromApiServer('POST', url, data);
}

export function fetchFundSectionReview(fund_ID) {
  const url = `funds/fund-sections-review/${fund_ID}`;
  return fetchFromApiServer('GET', url, fund_ID);
}

export function fetchSourceDocList(doc_path) {
  const url = `funds/fund-document-name`;
  return fetchFromApiServer('POST', url, doc_path);
}

export function fetchFundDocuments(fund_ID) {
  const url = `funds/fund-documents/${fund_ID}`;
  return fetchFromApiServer('GET', url, fund_ID);
}

export function fetchDocumentS3Paths(fund_ID) {
  const url = `funds/get-s3paths-chatAi`;
  return fetchFromApiServer('POST', url, fund_ID);
}

export function fetchFundDocumentsType(data) {
  const url = `funds/fund-document-type`;
  return fetchFromApiServer('PUT', url, data);
}

export function updateFundStatus(requestObject) {
  const url = `funds/update-fund-status`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function fetchFundPdfUrl(data) {
  const url = `funds/source-docs/signurl`;
  return fetchFromApiServer('POST', url, data);
}

export function fetchDisplayConfig(data) {
  const url = `funds/get-user-configs`;
  return fetchFromApiServer('POST', url, data);
}

export function updateBenchmarkQuartiles(data) {
  const url = `funds/update-benchmark-quartile`;
  return fetchFromApiServer('POST', url, data);
}

export function updateQuartileWithBenchmark(data) {
  const url = `funds/update-quartile-benchmark`;
  return fetchFromApiServer('POST', url, data);
}

export function addNotes(data) {
  const url = `funds/add-notes`;
  return fetchFromApiServer('POST', url, data);
}

export function updateNotes(data) {
  const url = `funds/update-notes`;
  return fetchFromApiServer('POST', url, data);
}

export function deleteNotes(data) {
  const url = `funds/delete-notes`;
  return fetchFromApiServer('POST', url, data);
}

export function getNotes(fund_id) {
  const url = `funds/get-notes/${fund_id}`;
  return fetchFromApiServer('GET', url, fund_id);
}

export function fetchPortfolioDetails(requestObject) {
  const url = `funds/person-details`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function fetchPersonDetails(requestObject) {
  const url = `funds/edit-Person-details`;
  return fetchFromApiServer('PUT', url, requestObject);
}

export function fetchCompanyDetailsEdit(requestObject) {
  const url = `funds/edit-Company-details`;
  return fetchFromApiServer('PUT', url, requestObject);
}

export function fetchContactDetailsEdit(requestObject) {
  const url = `contact-page/get-person-contacts`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function fetchFundManagerDetails(requestObject) {
  const url = `fundmanager-page/get-fund-manager`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function fetchCompanyAssetsDetails(requestObject) {
  const url = `company-page/get-company-details`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function fetchPortfolioCompanyDetails(requestObject) {
  const url = `funds/get-fund-portfolio-company`;
  return fetchFromApiServer('POST', url, requestObject);
}
export function fetchPortfolioTeamDetails(requestObject) {
  const url = `funds/getPortfolioTeams`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function updatingPortfolioCompany(requestObject) {
  const url = `funds/update-fund-portfolio-company`;
  return fetchFromApiServer('PUT', url, requestObject);
}

export function updatingPortfolioTeam(requestObject) {
  const url = `funds/update-fund-portfolio-team`;
  return fetchFromApiServer('PUT', url, requestObject);
}

export function fetchDeletePortfolioCompany(requestObject) {
  const url = `funds/delete-fund-portfolio-company`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function fetchDeletePortfolioTeam(requestObject) {
  const url = `funds/delete-fund-portfolio-team`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function fetchingPortfolioCompanyJson(requestObject) {
  const url = `funds/update-fund-json-portfolio-company`;
  return fetchFromApiServer('PUT', url, requestObject);
}

export function fetchCompanyId(requestObject) {
  const url = `fundmanager-page/get-company_id`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function fetchUpdateFundManager(requestObject) {
  const url = `fundmanager-page/update-fund-manager`;
  return fetchFromApiServer('PUT', url, requestObject);
}

export function fetchUpdateCompanyAssets(requestObject) {
  const url = `company-page/update-company-details`;
  return fetchFromApiServer('PUT', url, requestObject);
}

export function fetchUpdateFundManagerJson(requestObject) {
  const url = `fundmanager-page/update-fundmanager-json`;
  return fetchFromApiServer('PUT', url, requestObject);
}

export function fetchAssociatedFundManager(requestObject) {
  const url = `fundmanager-page/associated-funds`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function fetchAssociatedCompanyAssets(requestObject) {
  const url = `company-page/associated-funds`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function fetchReferenceFundManager(requestObject) {
  const url = `fundmanager-page/get-reference-details`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function fetchPortfolioFundManager(requestObject) {
  const url = `fundmanager-page/get-portfolio-company`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function fetchTopLevelState(requestObject) {
  const url = `landing-page/top-level-stats`;
  return fetchFromApiServer('GET', url, requestObject);
}

export function fetchAssociatedInvestment(requestObject) {
  const url = `contact-page/get-associated-investment`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function fetchReferenceContacts(requestObject) {
  const url = `contact-page/get-Reference-person`;
  return fetchFromApiServer('POST', url, requestObject);
}

export function editContactDetails(requestObject) {
  const url = `contact-page/update-person-contact`;
  return fetchFromApiServer('PUT', url, requestObject);
}

export function fetchPortfolioLinkDetails(requestObject) {
  const url = `funds/person_company_retrive`;
  return fetchFromApiServer('POST', url, requestObject);
}
export function fetchCompanyDetails(requestObject) {
  const url = `funds/company-details`;
  return fetchFromApiServer('POST', url, requestObject);
}

// Add a new reference
export function addReference(requestObject) {
  const url = `references/add-reference`;
  return fetchFromApiServer('POST', url, requestObject);
}

// Edit an existing reference
export function editReference(requestObject) {
  const url = `references/edit-reference`;
  return fetchFromApiServer('POST', url, requestObject);
}

// Delete a reference
export function deleteReference(requestObject) {
  const url = `funds/delete-reference`;
  return fetchFromApiServer('DELETE', url, requestObject);
}

// Get all references for a specific fund
export function getReferences(fund_id) {
  const url = `references/get-references/${fund_id}`;
  return fetchFromApiServer('GET', url, fund_id);
}

// Get all references for a specific fund
export function getIndvReference(ref_id) {
  const url = `references/get-indv-reference/${ref_id}`;
  return fetchFromApiServer('GET', url, ref_id);
}

export function getAIICReport(data) {
  const url = `funds/generate-ic-report`;
  return fetchFromApiServer('POST', url, data);
}

export function fetchTemplatePPT(data) {
  const url = `funds/get-icreport-ppt-config`;
  return fetchFromApiServer('GET', url, data);
}

export function fetchIcReportCommitted(data) {
  const url = `ic-report-ppt/grouped-by-status`;
  return fetchFromApiServer('POST', url, data);
}
